<nav class="sidenav" [class.collapsed]="isNavbarCollapsed" id="scrollElement">
  <div class="nav-wraper" [ngSwitch]="isAuthenticated()">
    <ul>
      <div class="nav-item" *ngIf="canOpenDoor">
        <app-button
          class="open-door-btn"
          [ngClass]="{ 'open-door-btn--collapsed': isNavbarCollapsed }"
          size="M"
          variant="fill"
          color="orange"
          [class.records-page-button]="isOnRecordsPage()"
          (click)="onClickOpenDoor($event)"
        >
          <app-open-door-icon [size]="18" color="#000000"></app-open-door-icon>
          <span *ngIf="!isNavbarCollapsed">{{ 'records.openDoor' | translate }}</span>
        </app-button>
      </div>
      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/records"
          *canAccessFeature="FEATURES_ENUM.RECORDS"
          title="{{ 'global.menu.records' | translate }}"
          #recordsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-attendance-icon [size]="21" [selected]="recordsLink.isActive">
            </app-attendance-icon>

            <span class="nav-item-text" [translate]="'global.menu.records'">Records</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>
      <li *ngSwitchCase="true" class="nav-item" [class.active]="isPaymentsActive()">
        <a
          class="nav-link"
          routerLink="/payments"
          *canAccessFeature="FEATURES_ENUM.PAYMENTS"
          title="{{ 'global.menu.payments' | translate }}"
        >
          <span>
            <app-payments-icon [size]="20" [selected]="isPaymentsActive()"></app-payments-icon>
            <span class="nav-item-text" [translate]="'global.menu.payments'">Placanja</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/ticket-office"
          *canAccessFeature="FEATURES_ENUM.TICKET_OFFICE"
          title="{{ 'global.menu.ticketOffice' | translate }}"
          #ticketOfficeLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-ticket-office-icon
              [size]="20"
              [selected]="ticketOfficeLink.isActive"
            ></app-ticket-office-icon>
            <span class="nav-item-text" [translate]="'global.menu.ticketOffice'">Biletarnica</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/price-list"
          *canAccessFeature="FEATURES_ENUM.PRICE_LIST"
          title="{{ 'global.menu.pricelist' | translate }}"
          #pricelistLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-price-list-icon
              [size]="20"
              [selected]="pricelistLink.isActive"
            ></app-price-list-icon>
            <span class="nav-item-text" [translate]="'global.menu.pricelist'">Pricelist</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>
      <ng-container *ngSwitchCase="true">
        <li
          *ngIf="hasAnyBookingFeature()"
          ngbDropdown
          class="nav-item dropdown pointer"
          #bookingItem
        >
          <div
            class="dropdown-hover-area"
            (mouseenter)="onTriggerEnter('booking')"
            (mouseleave)="onTriggerLeave($event, 'booking')"
          >
            <a
              *ngIf="hasAnyBookingFeature()"
              class="nav-link"
              [ngClass]="{ selected: isBookingSelected }"
              [matMenuTriggerFor]="isNavbarCollapsed ? bookingFlyout : null"
              #bookingTrigger="matMenuTrigger"
              (click)="onTriggerClick('booking', $event)"
              title="{{ 'bookingApp.global.menu.booking' | translate }}"
            >
              <span>
                <app-arrow-icon
                  class="submenu-arrow left"
                  [expanded]="!isBookingCollapsed"
                ></app-arrow-icon>
                <app-reservations-icon
                  [size]="20"
                  [selected]="false"
                  [color]="
                    isBookingSelected && isNavbarCollapsed ? 'var(--menu-text-active)' : undefined
                  "
                ></app-reservations-icon>
                <span class="nav-item-text" [translate]="'bookingApp.global.menu.booking'"
                  >Booking</span
                >
              </span>
            </a>
            <div *ngIf="isNavbarCollapsed && isBookingSelected" class="active-indicator"></div>
          </div>

          <ng-template #bookingMenu>
            <ul *ngIf="hasAnyBookingFeature()">
              <li
                *ngIf="permitedScheduleAppointment"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.schedule-appointment'"
                  routerLink="booking/schedule-appointment"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.schedule-appointment' | translate }}"
                >
                  <span class="pill-label">Zakazivanje termina</span>
                </a>
              </li>
              <li
                *ngIf="permitedReservation"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.schedule'"
                  routerLink="booking/reservation"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.schedule' | translate }}"
                >
                  <span class="pill-label">Dnevnik rezervacija</span>
                </a>
              </li>
              <li
                *ngIf="permitedResourceReservationSchedule"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.resourceSchedule'"
                  routerLink="booking/resource-reservation-schedule"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.resourceSchedule' | translate }}"
                >
                  <span class="pill-label">Raspored po resursima</span>
                </a>
              </li>
              <li
                *ngIf="permitedCustomerReservationSchedule"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.userUtilitySchedule'"
                  routerLink="booking/customer-reservation-schedule"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.userUtilitySchedule' | translate }}"
                >
                  <span class="pill-label">Raspored po korisnicima i uslugama</span>
                </a>
              </li>
              <!-- "Kalendar za pojedinacan resurs" – sklonjeno iz menija, funkcionalnost dostupna kroz ostale rasporede
              <li
                *ngIf="permitedCalendarIndividualResource"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.calendar'"
                  routerLink="booking/calendar-for-an-individual-resource"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.calendar' | translate }}"
                >
                  <span class="pill-label">Kalendar za pojedinacan resurs</span>
                </a>
              </li>
              -->
              <li
                *ngIf="permitedUser"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.user-card'"
                  routerLink="booking/user"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.user-card' | translate }}"
                >
                  <span class="pill-label">Kartica korisnika</span>
                </a>
              </li>
              <li
                *ngIf="permitedResourceOccupancy"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.resourceUtilityOccupancy'"
                  routerLink="booking/resource-occupancy"
                  routerLinkActive="active"
                  title="{{
                    'bookingApp.global.menu.entities.resourceUtilityOccupancy' | translate
                  }}"
                >
                  <span class="pill-label">Zauzetost resursa/usluga</span>
                </a>
              </li>
              <li
                *ngIf="permitedScheduleIndividualResource"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.individualResourceSchedule'"
                  routerLink="booking/schedule-for-an-individual-resource"
                  routerLinkActive="active"
                  title="{{
                    'bookingApp.global.menu.entities.individualResourceSchedule' | translate
                  }}"
                >
                  <span class="pill-label">Raspored za pojedinacan resurs</span>
                </a>
              </li>
              <li
                *ngIf="permitedWorkHours"
                class="collapse-item"
                routerLinkActive="active"
              >
              <a
                [translate]="'bookingApp.global.menu.entities.workHours'"
                routerLink="booking/work-hours/new"
                routerLinkActive="active"
                title="{{ 'bookingApp.global.menu.entities.workHours' | translate }}"
            >
              <span class="pill-label">Radni sati</span>
            </a>
              </li>
              <li
                *ngIf="permitedResource"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.resource'"
                  routerLink="booking/resource"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.resource' | translate }}"
                >
                  <span class="pill-label">Resursi</span>
                </a>
              </li>
              <li
                *ngIf="permitedUtility"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.services'"
                  routerLink="booking/utility"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.services' | translate }}"
                >
                  <span class="pill-label">Usluge</span>
                </a>
              </li>
              <li
                *ngIf="permitedAsset"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.asset'"
                  routerLink="booking/asset"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.asset' | translate }}"
                >
                  <span class="pill-label">Sredstva za rad</span>
                </a>
              </li>
              <li
                *ngIf="permitedCustomerStatus"
                class="collapse-item"
                routerLinkActive="active"
              >
                <a
                  [translate]="'bookingApp.global.menu.entities.customerStatus'"
                  routerLink="booking/customer-status"
                  routerLinkActive="active"
                  title="{{ 'bookingApp.global.menu.entities.customerStatus' | translate }}"
                >
                  <span class="pill-label">Statusi korisnika</span>
                </a>
              </li>
            </ul>
          </ng-template>
          <div *ngIf="!isBookingCollapsed" class="submenu">
            <ng-container [ngTemplateOutlet]="bookingMenu"></ng-container>
          </div>
          <mat-menu
            #bookingFlyout="matMenu"
            class="nav-flyout-menu"
            [overlapTrigger]="false"
            xPosition="after"
            [hasBackdrop]="false"
          >
            <div
              class="flyout-container"
              (mouseenter)="onMenuEnter('booking')"
              (mouseleave)="onMenuLeave('booking')"
              (click)="closeFlyout('booking')"
            >
              <ng-container [ngTemplateOutlet]="bookingMenu"></ng-container>
            </div>
          </mat-menu>
        </li>
      </ng-container>

      <!-- Show IDS (user administration) if user is admin or has USER_ADMINISTRATION feature -->
      <ng-container *ngIf="hasIdsAccess()">
        <li *ngSwitchCase="true" ngbDropdown class="nav-item dropdown pointer" #idsItem>
          <div
            class="dropdown-hover-area"
            (mouseenter)="onTriggerEnter('ids')"
            (mouseleave)="onTriggerLeave($event, 'ids')"
          >
            <a
              class="nav-link"
              [ngClass]="{ selected: isIdsSelected }"
              [matMenuTriggerFor]="isNavbarCollapsed ? idsFlyout : null"
              #idsTrigger="matMenuTrigger"
              (click)="onTriggerClick('ids', $event)"
              title="{{ 'idsApp.global.menu.idsUrl' | translate }}"
            >
              <span>
                <app-arrow-icon
                  class="submenu-arrow left"
                  [expanded]="!isIdsCollapsed"
                ></app-arrow-icon>
                <app-user-admin-icon
                  [size]="21"
                  [selected]="false"
                  [color]="
                    isIdsSelected && isNavbarCollapsed ? 'var(--menu-text-active)' : undefined
                  "
                ></app-user-admin-icon>

                <span class="nav-item-text" [translate]="'idsApp.global.menu.idsUrl'"
                  >Administracija korisnika</span
                >
              </span>
            </a>
            <div *ngIf="isNavbarCollapsed && isIdsSelected" class="active-indicator"></div>
          </div>

          <ng-template #idsMenu>
            <ul>
              <li class="collapse-item" routerLinkActive="active">
                <a
                  [translate]="'idsApp.global.menu.users'"
                  routerLink="ids/techno-user"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.users' | translate }}"
                  >Korisnici</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active">
                <a
                  [translate]="'idsApp.global.menu.entities.technoCard'"
                  routerLink="ids/techno-card"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.entities.technoCard' | translate }}"
                  >Kartice</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active">
                <a
                  [translate]="'idsApp.global.menu.entities.technoQr'"
                  routerLink="ids/techno-qr"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.entities.technoQr' | translate }}"
                  >QR</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active">
                <a
                  [translate]="'idsApp.global.menu.entities.organization'"
                  routerLink="ids/organization"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.entities.organization' | translate }}"
                  >Tip Korisnika</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active" *appHasAnyAuthority="'ROLE_ADMIN'">
                <a
                  [translate]="'idsApp.global.menu.entities.company'"
                  routerLink="ids/company"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.entities.company' | translate }}"
                  >Teretana</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active" *appHasAnyAuthority="'ROLE_ADMIN'">
                <a
                  [translate]="'idsApp.global.menu.admin.userManagement'"
                  routerLink="ids/user-management"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.admin.userManagement' | translate }}"
                  >Korisnicki menadzment</a
                >
              </li>
              <li class="collapse-item" routerLinkActive="active" *appHasAnyAuthority="'ROLE_ADMIN'">
                <a
                  [translate]="'idsApp.global.menu.entities.role'"
                  routerLink="ids/role"
                  routerLinkActive="active"
                  title="{{ 'idsApp.global.menu.entities.role' | translate }}"
                  >Role</a
                >
              </li>
            </ul>
          </ng-template>
          <div *ngIf="!isIdsCollapsed" class="submenu">
            <ng-container [ngTemplateOutlet]="idsMenu"></ng-container>
          </div>
          <mat-menu
            #idsFlyout="matMenu"
            class="nav-flyout-menu"
            [overlapTrigger]="false"
            xPosition="after"
            [hasBackdrop]="false"
          >
            <div
              class="flyout-container"
              (mouseenter)="onMenuEnter('ids')"
              (mouseleave)="onMenuLeave('ids')"
              (click)="closeFlyout('ids')"
            >
              <ng-container [ngTemplateOutlet]="idsMenu"></ng-container>
            </div>
          </mat-menu>
        </li>
      </ng-container>

      <ng-container *ngSwitchCase="true">
        <li
          *ngIf="hasAnyReportFeature()"
          ngbDropdown
          class="nav-item dropdown pointer"
          #reportsItem
        >
        <div
          class="dropdown-hover-area"
          (mouseenter)="onTriggerEnter('report')"
          (mouseleave)="onTriggerLeave($event, 'report')"
        >
          <a
            class="nav-link"
            [ngClass]="{ selected: isReportsSelected }"
            [matMenuTriggerFor]="isNavbarCollapsed ? reportsFlyout : null"
            #reportsTrigger="matMenuTrigger"
            (click)="onTriggerClick('report', $event)"
            title="{{ 'global.menu.reports' | translate }}"
          >
            <span>
              <app-arrow-icon
                class="submenu-arrow left"
                [expanded]="!isReportsCollapsed"
              ></app-arrow-icon>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 -0.00012207H2C0.9 -0.00012207 0 0.899878 0 1.99988V15.9999C0 17.0999 0.9 17.9999 2 17.9999H16C17.1 17.9999 18 17.0999 18 15.9999V1.99988C18 0.899878 17.1 -0.00012207 16 -0.00012207ZM16 15.9999H2V1.99988H16V15.9999Z"
                  fill="#BDBDBD"
                />
                <path d="M6 8.99988H4V13.9999H6V8.99988Z" fill="#BDBDBD" />
                <path d="M14 3.99988H12V13.9999H14V3.99988Z" fill="#BDBDBD" />
                <path d="M10 10.9999H8V13.9999H10V10.9999Z" fill="#BDBDBD" />
                <path d="M10 6.99988H8V8.99988H10V6.99988Z" fill="#BDBDBD" />
              </svg>
              <span class="nav-item-text" [translate]="'global.menu.reports'">Izveštaji</span>
            </span>
          </a>
          <div *ngIf="isNavbarCollapsed && isReportsSelected" class="active-indicator"></div>
        </div>

        <ng-template #reportsMenu>
          <ul>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_USER_OVERVIEW"
            >
              <a
                [translate]="'global.menu.memberReview'"
                routerLink="reports/members-overview"
                routerLinkActive="active"
                title="{{ 'global.menu.memberReview' | translate }}"
                >Pregled korisnika</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_USER_CARD"
            >
              <a
                [translate]="'global.menu.userCard'"
                routerLink="reports/user-card"
                routerLinkActive="active"
                title="{{ 'global.menu.userCard' | translate }}"
                >Kartica korisnika</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_ATTENDANCE_OVERVIEW"
            >
              <a
                [translate]="'global.menu.attendanceOverview'"
                routerLink="reports/attendance-overview"
                routerLinkActive="active"
                title="{{ 'global.menu.attendanceOverview' | translate }}"
                >Pregled prisutnosti</a
              >
              <div class="active-indicator"></div>
            </li>
            <!-- TODO -->
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_NEW_REGISTRATIONS"
            >
              <a
                [translate]="'global.menu.newRegistrationsForPeriod'"
                routerLink="reports/new-registrations"
                routerLinkActive="active"
                title="{{ 'global.menu.newRegistrationsForPeriod' | translate }}"
                >Nove registracije za period</a
              >
              <div class="active-indicator"></div>
            </li>
            <!-- TODO -->
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_EXPIRED_MEMBERSHIPS"
            >
              <a
                [translate]="'global.menu.expiredMembershipsForPeriod'"
                routerLink="reports/expired-memberships"
                routerLinkActive="active"
                title="{{ 'global.menu.expiredMembershipsForPeriod' | translate }}"
                >Istekle clanarine za period</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_ATTENDANCE_DIAGRAM"
            >
              <a
                [translate]="'global.menu.attendanceDiagram'"
                routerLink="reports/attendance-diagram"
                routerLinkActive="active"
                title="{{ 'global.menu.attendanceDiagram' | translate }}"
                >Dijagram prisutnosti</a
              >
              <div class="active-indicator"></div>
            </li>
            <!-- *ngIf="benefitCorporate" -->
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_GYM_VISITS"
            >
              <a
                [translate]="'global.menu.visitCountPerGym'"
                routerLink="reports/visit-count-per-gym"
                routerLinkActive="active"
                title="{{ 'global.menu.visitCountPerGym' | translate }}"
                >Broj poseta po teretanama</a
              >
              <div class="active-indicator"></div>
            </li>
            <!-- *ngIf="benefitCorporate" -->
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_EXTERNAL_CENTERS_OBLIGATIONS"
            >
              <a
                [translate]="'global.menu.overviewOfObligationToOtherCenters'"
                routerLink="reports/external-centers-obligations"
                routerLinkActive="active"
                title="{{ 'global.menu.overviewOfObligationToOtherCenters' | translate }}"
                >Pregled obaveza ka teretanama</a
              >
              <div class="active-indicator"></div>
            </li>
            <!-- TODO -->
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_MEMBERSHIP_REVENUE"
            >
              <a
                [translate]="'global.menu.paymentsForPeriod'"
                routerLink="reports/members-payments"
                routerLinkActive="active"
                title="{{ 'global.menu.paymentsForPeriod' | translate }}"
                >Pregled prihoda od članarina</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_MEMBERSHIP_REVENUE"
            >
              <a
                [translate]="'global.menu.soldTicketsByOrganization'"
                routerLink="reports/sold-tickets-by-organization"
                routerLinkActive="active"
                title="{{ 'global.menu.soldTicketsByOrganization' | translate }}"
                >Prodate ulaznice za period</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_MEMBERSHIP_REVENUE"
            >
              <a
                [translate]="'global.menu.paymentsByOperator'"
                routerLink="reports/payments-by-operator"
                routerLinkActive="active"
                title="{{ 'global.menu.paymentsByOperator' | translate }}"
                >Pregled uplata po operaterima</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_ATTENDANCE_OVERVIEW"
            >
              <a
                [translate]="'global.menu.doorOpenings'"
                routerLink="reports/door-openings"
                routerLinkActive="active"
                title="{{ 'global.menu.doorOpenings' | translate }}"
                >Izveštaj otvaranja vrata</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_BAR"
            >
              <a
                [translate]="'global.menu.overviewOfIncomeForBar'"
                routerLink="reports/bar-report"
                routerLinkActive="active"
                title="{{ 'global.menu.overviewOfIncomeForBar' | translate }}"
                >Pregled prihoda od bara</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_BUSINESS"
            >
              <a
                [translate]="'global.menu.costOverview'"
                routerLink="reports/business-report"
                routerLinkActive="active"
                title="{{ 'global.menu.costOverview' | translate }}"
                >Pregled troskova</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.REPORT_BUSINESS_FOR_PERIOD"
            >
              <a
                [translate]="'global.menu.businessForPeriod'"
                routerLink="reports/business-for-period"
                routerLinkActive="active"
                title="{{ 'global.menu.businessForPeriod' | translate }}"
                >Poslovanje za period</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.TRAINERS_OVERVIEW"
            >
              <!--*canAccessFeature="FEATURES_ENUM.PREGLED_PO_TRNERIMA"-->
              <a
                [translate]="'global.menu.trainerOverview'"
                routerLink="reports/trainers-overview"
                routerLinkActive="active"
                title="{{ 'global.menu.trainerOverview' | translate }}"
                >Pregled po trenerima</a
              >
              <div class="active-indicator"></div>
            </li>
            <li
              class="collapse-item"
              routerLinkActive="active"
              *canAccessFeature="FEATURES_ENUM.TAXES_OVERVIEW"
            >
              <!--*canAccessFeature="FEATURES_ENUM.PREGLED_PO_TRNERIMA"-->
              <a
                [translate]="'global.menu.pregledPoRacunima'"
                routerLink="reports/taxes-overview"
                routerLinkActive="active"
                title="{{ 'global.menu.pregledPoRacunima' | translate }}"
                >Pregled po racunima</a
              >
              <div class="active-indicator"></div>
            </li>
          </ul>
        </ng-template>
        <div *ngIf="!isReportsCollapsed" class="submenu">
          <ng-container [ngTemplateOutlet]="reportsMenu"></ng-container>
        </div>
        <mat-menu
          #reportsFlyout="matMenu"
          class="nav-flyout-menu"
          [overlapTrigger]="false"
          xPosition="after"
          [hasBackdrop]="false"
        >
          <div
            class="flyout-container"
            (mouseenter)="onMenuEnter('report')"
            (mouseleave)="onMenuLeave('report')"
            (click)="closeFlyout('report')"
          >
            <ng-container [ngTemplateOutlet]="reportsMenu"></ng-container>
          </div>
        </mat-menu>
      </li>
      </ng-container>

      <li
        *ngSwitchCase="true"
        class="nav-item hide-mobile"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/chat/home"
          *canAccessFeature="FEATURES_ENUM.MESSAGES"
          title="{{ 'global.menu.messages' | translate }}"
          #messagesLink="routerLinkActive"
          routerLinkActive
        >
          <span class="nav-link-content">
            <app-messages-icon [size]="20" [selected]="messagesLink.isActive"></app-messages-icon>

            <span class="nav-item-text" [translate]="'global.menu.messages'">Messages</span>
            <span class="badge badge-danger" *ngIf="newMessagesCount > 0">{{ newMessagesCount }}</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/jobs"
          *canAccessFeature="FEATURES_ENUM.MARKETING"
          title="{{ 'global.menu.job' | translate }}"
          #marketingLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-marketing-icon
              [size]="21"
              [selected]="marketingLink.isActive"
            ></app-marketing-icon>
            <span class="nav-item-text" [translate]="'global.menu.job'">Jobs</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/settings"
          *canAccessFeature="FEATURES_ENUM.SETTINGS"
          title="{{ 'global.menu.account.settings' | translate }}"
          #settingsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-settings-icon [size]="21" [selected]="settingsLink.isActive"></app-settings-icon>
            <span class="nav-item-text" [translate]="'global.menu.account.settings'">Settings</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/params"
          *canAccessFeature="FEATURES_ENUM.PARAMETRI"
          #paramsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-params-icon
              [size]="21"
              [selected]="paramsLink.isActive"
            ></app-params-icon>
            <span class="nav-item-text" [translate]="'global.menu.params'">Params</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/open-items"
          *canAccessFeature="FEATURES_ENUM.OPEN_ITEMS"
          #openItemsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-open-items-icon
              [size]="21"
              [selected]="openItemsLink.isActive"
            ></app-open-items-icon>
            <span class="nav-item-text" [translate]="'global.menu.openItems'">Open items</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/contracts"
          *canAccessFeature="FEATURES_ENUM.CONTRACTS"
          title="{{ 'global.menu.contract' | translate }}"
          #contractsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-contracts-icon
              [size]="20"
              [selected]="contractsLink.isActive"
            ></app-contracts-icon>
            <span class="nav-item-text" [translate]="'global.menu.contract'">Contracts</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/locations"
          *canAccessFeature="FEATURES_ENUM.LOCATIONS"
          title="{{ 'global.menu.location' | translate }}"
          #locationsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-locations-icon
              [size]="21"
              [selected]="locationsLink.isActive"
            ></app-locations-icon>
            <span class="nav-item-text" [translate]="'global.menu.location'">Locations</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/utility"
          *canAccessFeature="FEATURES_ENUM.SERVICES"
          title="{{ 'global.menu.utilities' | translate }}"
          #servicesLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-services-icon [size]="21" [selected]="servicesLink.isActive"></app-services-icon>
            <span class="nav-item-text" [translate]="'global.menu.entities.utility'">Utility</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/item"
          *canAccessFeature="FEATURES_ENUM.BAR_ITEMS"
          title="{{ 'global.menu.items' | translate }}"
          #barItemsLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-bar-items-icon [size]="21" [selected]="barItemsLink.isActive"></app-bar-items-icon>
            <span class="nav-item-text" [translate]="'global.menu.items'">Artikli</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/cost-type"
          *canAccessFeature="FEATURES_ENUM.EXPENSE_TYPES"
          #costsTypesLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-costs-list-icon
              [size]="20"
              [selected]="costsTypesLink.isActive"
            ></app-costs-list-icon>
            <span class="nav-item-text" [translate]="'global.menu.costTypes'">Troskovi</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/partner"
          *canAccessFeature="FEATURES_ENUM.PARTNER"
          title="{{ 'global.menu.partner' | translate }}"
          #partnerLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-partners-icon [size]="21" [selected]="partnerLink.isActive"></app-partners-icon>
            <span class="nav-item-text" [translate]="'global.menu.partner'">Partner</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <!-- <li *ngSwitchCase="true" class="nav-item" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link" routerLink="/sifarnik-troskova" *ngIf="checkUser">
                <span>
                    <fa-icon icon="credit-card"></fa-icon>
                    <span class="nav-item-text" [translate]="global.menu.itemManager" >Sif art</span>
                </span>
            </a>
            <div class="active-indicator"></div>
            </li> -->

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/bill-list"
          *canAccessFeature="FEATURES_ENUM.BAR"
          title="{{ 'global.menu.costs' | translate }}"
          #barStoreLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-bar-store-icon [size]="21" [selected]="barStoreLink.isActive"></app-bar-store-icon>
            <span class="nav-item-text" [translate]="'global.menu.costs'">Troskovi</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/business"
          *canAccessFeature="FEATURES_ENUM.BUSINESS"
          title="{{ 'global.menu.business' | translate }}"
          #businessLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-business-icon [size]="21" [selected]="businessLink.isActive"></app-business-icon>
            <span class="nav-item-text" [translate]="'global.menu.business'">Poslovanje</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>

      <li
        *ngSwitchCase="true"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <a
          class="nav-link"
          routerLink="/keys-list"
          *canAccessFeature="FEATURES_ENUM.KEY_LIST"
          title="{{ 'global.menu.keysList' | translate }}"
          #keysListLink="routerLinkActive"
          routerLinkActive
        >
          <span>
            <app-keys-list-icon [size]="20" [selected]="keysListLink.isActive"></app-keys-list-icon>
            <span class="nav-item-text" [translate]="'global.menu.keysList'">Keys List</span>
          </span>
        </a>
        <div class="active-indicator"></div>
      </li>
    </ul>
  </div>

  <div class="collapse-navbar nav-wraper">
    <ul>
      <li class="collapse-item">
        <a
          (click)="collapseNavbar()"
          *ngIf="!isNavbarCollapsed"
          title="{{ 'global.menu.collapseNavbar' | translate }}"
          class="toggle-btn"
        >
          <!-- Revert to original icon asset (no flip when expanded) -->
          <svg
            class="toggle-icon"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_3006_12213)">
              <path
                d="M16 30C15.7167 30 15.4792 29.9042 15.2875 29.7125C15.0958 29.5208 15 29.2833 15 29C15 28.7167 15.0958 28.4792 15.2875 28.2875C15.4792 28.0958 15.7167 28 16 28H27C27.2833 28 27.5208 28.0958 27.7125 28.2875C27.9042 28.4792 28 28.7167 28 29C28 29.2833 27.9042 29.5208 27.7125 29.7125C27.5208 29.9042 27.2833 30 27 30H16ZM30.9 28.3L27.3 24.7C27.1 24.5 27 24.2667 27 24C27 23.7333 27.1 23.5 27.3 23.3L30.9 19.7C31.0833 19.5167 31.3167 19.425 31.6 19.425C31.8833 19.425 32.1167 19.5167 32.3 19.7C32.4833 19.8833 32.575 20.1167 32.575 20.4C32.575 20.6833 32.4833 20.9167 32.3 21.1L29.4 24L32.3 26.9C32.4833 27.0833 32.575 27.3167 32.575 27.6C32.575 27.8833 32.4833 28.1167 32.3 28.3C32.1167 28.4833 31.8833 28.575 31.6 28.575C31.3167 28.575 31.0833 28.4833 30.9 28.3ZM16 25C15.7167 25 15.4792 24.9042 15.2875 24.7125C15.0958 24.5208 15 24.2833 15 24C15 23.7167 15.0958 23.4792 15.2875 23.2875C15.4792 23.0958 15.7167 23 16 23H24C24.2833 23 24.5208 23.0958 24.7125 23.2875C24.9042 23.4792 25 23.7167 25 24C25 24.2833 24.9042 24.5208 24.7125 24.7125C24.5208 24.9042 24.2833 25 24 25H16ZM16 20C15.7167 20 15.4792 19.9042 15.2875 19.7125C15.0958 19.5208 15 19.2833 15 19C15 18.7167 15.0958 18.4792 15.2875 18.2875C15.4792 18.0958 15.7167 18 16 18H27C27.2833 18 27.5208 18.0958 27.7125 18.2875C27.9042 18.4792 28 18.7167 28 19C28 19.2833 27.9042 19.5208 27.7125 19.7125C27.5208 19.9042 27.2833 20 27 20H16Z"
                fill="var(--collapse-icon-fill)"
              />
            </g>
            <rect
              x="0.5"
              y="0.5"
              width="47"
              height="47"
              rx="23.5"
              stroke="var(--collapse-icon-stroke)"
            />
            <defs>
              <clipPath id="clip0_3006_12213">
                <rect width="48" height="48" rx="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <a
          (click)="expandNavbar()"
          *ngIf="isNavbarCollapsed"
          title="{{ 'global.menu.expandNavbar' | translate }}"
          class="toggle-btn"
        >
          <!-- Right arrow when collapsed (flip original icon) -->
          <svg
            class="toggle-icon flip-x"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_3006_12213)">
              <path
                d="M16 30C15.7167 30 15.4792 29.9042 15.2875 29.7125C15.0958 29.5208 15 29.2833 15 29C15 28.7167 15.0958 28.4792 15.2875 28.2875C15.4792 28.0958 15.7167 28 16 28H27C27.2833 28 27.5208 28.0958 27.7125 28.2875C27.9042 28.4792 28 28.7167 28 29C28 29.2833 27.9042 29.5208 27.7125 29.7125C27.5208 29.9042 27.2833 30 27 30H16ZM30.9 28.3L27.3 24.7C27.1 24.5 27 24.2667 27 24C27 23.7333 27.1 23.5 27.3 23.3L30.9 19.7C31.0833 19.5167 31.3167 19.425 31.6 19.425C31.8833 19.425 32.1167 19.5167 32.3 19.7C32.4833 19.8833 32.575 20.1167 32.575 20.4C32.575 20.6833 32.4833 20.9167 32.3 21.1L29.4 24L32.3 26.9C32.4833 27.0833 32.575 27.3167 32.575 27.6C32.575 27.8833 32.4833 28.1167 32.3 28.3C32.1167 28.4833 31.8833 28.575 31.6 28.575C31.3167 28.575 31.0833 28.4833 30.9 28.3ZM16 25C15.7167 25 15.4792 24.9042 15.2875 24.7125C15.0958 24.5208 15 24.2833 15 24C15 23.7167 15.0958 23.4792 15.2875 23.2875C15.4792 23.0958 15.7167 23 16 23H24C24.2833 23 24.5208 23.0958 24.7125 23.2875C24.9042 23.4792 25 23.7167 25 24C25 24.2833 24.9042 24.5208 24.7125 24.7125C24.5208 24.9042 24.2833 25 24 25H16ZM16 20C15.7167 20 15.4792 19.9042 15.2875 19.7125C15.0958 19.5208 15 19.2833 15 19C15 18.7167 15.0958 18.4792 15.2875 18.2875C15.4792 18.0958 15.7167 18 16 18H27C27.2833 18 27.5208 18.0958 27.7125 18.2875C27.9042 18.4792 28 18.7167 28 19C28 19.2833 27.9042 19.5208 27.7125 19.7125C27.5208 19.9042 27.2833 20 27 20H16Z"
                fill="var(--collapse-icon-fill)"
              />
            </g>
            <rect
              x="0.5"
              y="0.5"
              width="47"
              height="47"
              rx="23.5"
              stroke="var(--collapse-icon-stroke)"
            />
            <defs>
              <clipPath id="clip0_3006_12213">
                <rect width="48" height="48" rx="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
      </li>
    </ul>
  </div>
</nav>
